import React from 'react';
import { TextField } from '@mui/material';
import { CallLogFormErrors } from '../hooks';

interface CallRecipientFieldProps {
  value: string;
  error: string;
  onChange: (value: string) => void;
}

export const CallRecipientField: React.FC<CallRecipientFieldProps> = ({
  value,
  error,
  onChange
}) => {
  return (
    <TextField
      label="Called To"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={!!error}
      helperText={error || 'Who was contacted (patient, insurance, provider, etc.)'}
      size="small"
      required
      fullWidth
    />
  );
};
